import template from './overlay.tmpl.html'

export default [overlay]

function overlay() {
  return {
    template,
    transclude: true,
    replace: true,
    restrict: 'E',
    scope: {
      // it can receive it by default
      // or it can respond to rootscope events
      visible: '=',
      onclick: '=clickCallback',
    },
    controller: ['$rootScope', '$timeout', Overlay],
    controllerAs: 'vm',
    bindToController: true,
  }
}

export function Overlay($rootScope, $timeout) {
  $rootScope.$on('DISPATCH', (sender, action) => {
    if (action.type === 'OVERLAY_SHOW') {
      this.visible = true
    }
    if (action.type === 'OVERLAY_HIDE') {
      this.visible = false
    }
  })
  this.handleClick = (e) => {
    // kinda hacky
    if (e.target.className.indexOf('overlay') < 0) {
      return
    }
    this.visible = false
    if (typeof this.onclick === 'function') {
      this.onclick(e)
    }
  }
}
